import {
  ChangeDetectionStrategy,
  Component,
  ViewChild,
  ElementRef,
  PLATFORM_ID,
  OnDestroy,
  inject,
  signal,
} from "@angular/core";
import { isPlatformBrowser } from "@angular/common";
import { Store } from "@ngrx/store";

import { CoreActions } from "src/app/core/store/actions";
import { Seo } from "src/app/core/services/seo.service";
import { environment } from "src/environments/environment";

@Component({
  selector: "audio-blog",
  templateUrl: "./blog.component.html",
  styleUrls: ["./blog.component.sass"],

  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BlogComponent implements OnDestroy {
  private store = inject(Store);
  private seo = inject(Seo);
  platformId = inject(PLATFORM_ID);

  @ViewChild("instagramFeed") instagramFeed!: ElementRef;

  private $removeInterval = signal<ReturnType<typeof setInterval> | null>(null);

  constructor() {
    this.seo.setMeta({ property: "og:type", content: "website" });
    this.seo.setTitle("Blog | " + environment.title);
    this.seo.setDescription(
      "Retrouvez les dernières actualités de TECHNOMAD AUDIO.",
    );
    this.seo.setImage(
      environment.fullUrl + "/assets/imgs/sonorisation-fontevraud.jpg",
    );
    this.store.dispatch(
      new CoreActions.SetBreadcrumb({
        label: "Actualité",
        slug: "blog",
        entity: "page",
      }),
    );

    if (isPlatformBrowser(this.platformId)) {
      const intervalId = setInterval(() => {
        const elements = this.instagramFeed.nativeElement.querySelectorAll(
          'a[href^="https://elfsight.com"]',
        );

        if (elements.length > 0) {
          elements.forEach((element: Element) => {
            element.parentNode?.removeChild(element);
          });
          clearInterval(intervalId);
          this.$removeInterval.set(null);
        } else {
          this.$removeInterval.set(intervalId);
        }
      }, 1);
    }
  }

  ngOnDestroy() {
    const interval = this.$removeInterval();
    if (interval) {
      clearInterval(interval);
    }
  }
}
